import { Button } from '@/components/ui/button';
import { DEVICE_LOG_TYPES, getDeviceLogTypeMeta, type DeviceLogType } from '@/entities/device-log-type-meta';

const DEVICE_LOG_TYPE_LABELS: Record<DeviceLogType, string> = {
	crash: 'Краш',
	anr: 'ANR',
	native: 'Native',
	error: 'Ошибка',
	abnormal_exit: 'Выход',
};

interface ClientDeviceLogTypeFilterProps {
	selected: DeviceLogType[];
	onChange: (types: DeviceLogType[]) => void;
}

export default function ClientDeviceLogTypeFilter({ selected, onChange }: ClientDeviceLogTypeFilterProps) {
	return (
		<div className='flex flex-wrap gap-1.5 px-2 pb-2'>
			{DEVICE_LOG_TYPES.map(type => {
				const active = selected.includes(type);
				const meta = getDeviceLogTypeMeta(type);
				return (
					<Button
						key={type}
						type='button'
						size='sm'
						variant={active ? 'secondary' : 'outline'}
						className='h-8'
						onClick={() => {
							const next = active ? selected.filter(t => t !== type) : [...selected, type];
							onChange(next);
						}}
					>
						{DEVICE_LOG_TYPE_LABELS[type] ?? meta.label}
					</Button>
				);
			})}
		</div>
	);
}
